export default __webpack_public_path__ + "images/ded6828e58d2b581967f0baf40b5143c-mental_health.jpg";